import { render, staticRenderFns } from "./appointment-report-read.vue?vue&type=template&id=36077f42&"
import script from "./appointment-report-read.vue?vue&type=script&lang=js&"
export * from "./appointment-report-read.vue?vue&type=script&lang=js&"
import style0 from "./appointment-report-read.vue?vue&type=style&index=0&module=true&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports